module.exports = __webpack_public_path__ + "img/ic_facebook_original.18afb63a.svg";